module.exports = __webpack_public_path__ + "media/brands/buerstner-ab769a64.png";